export const DateOptions = [
    { key: "1", value: "Since account opening" },
    { key: "2", value: "Past tax year" },
    { key: "3", value: "Current tax year" },
    { key: "4", value: "Past year" },
    { key: "5", value: "Past 6 months" },
    { key: "6", value: "Past 3 months" },
    { key: "7", value: "Custom" },
];

export const Contents = {
    From: "From",
    To: "To",
    InvalidDateErrorMsg: "Invalid date period",
    AcceptDateFormatsErrorMsg: "Incorrect date format. Enter as dd/mm/yyyy.",
    DateCanNotInFuture: "Date cannot be in the future",
    DateCanNotInPast: "Date cannot precede inception date",
    DateNoMoreThanOneYearApart: "Date range cannot be more than one year",
    CanNotEmpty: "Can't be empty",
    OktaUserSettingPathSegment: "/enduser/settings",
    Header_Error: "Error",
};
